import { BalanceText, IconButton, Shadow, Text, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

import {
  TableContentItemBadge,
  TableContentItemCaptions,
} from '../../../../../../components/TableContent';
import { mapCaptions } from '../../../../utils';
import { ItemTag } from '../../../Customer/components/ItemTag';

import { AddedCustomerItemResponsiveProps } from '.';

export const AddedCustomerItemDesktop: React.FC<AddedCustomerItemResponsiveProps> = ({
  item,
  handleRemoveCustomerToCart,
  handleUpdateBalance,
  isLoadingBalance,
}) => {
  return (
    <Shadow borderRadius={BoxRadius.xs} level={2}>
      <HStack p={Spacing['inline.xxs']} alignItems="center" borderRadius={BoxRadius.xs}>
        <HStack space={Spacing['inline.xxs']} flex={1}>
          <VStack space={Spacing['stack.quarck']} flex={1} maxW={'180px'}>
            <Text fontSize={Typography['fontsize.xs']} color="neutral.dark">
              Cliente
            </Text>
            <Text noOfLines={2} fontSize={Typography['fontsize.md']} color="neutral.darkest">
              {item.name}
            </Text>
            <HStack space={Spacing['inline.nano']} alignItems="center">
              <Text fontSize={Typography['fontsize.xs']} color="neutral.dark">
                Conta
              </Text>
              <Text fontSize={Typography['fontsize.xs']} color="neutral.dark">
                {item.accountNumber}
              </Text>
              <TableContentItemCaptions forceDesktop icons={mapCaptions(item)} />
            </HStack>
          </VStack>
          <VStack space={Spacing['stack.quarck']} flex={1} maxW={'100px'}>
            <Text fontSize={Typography['fontsize.xs']} color="neutral.dark">
              Suitability
            </Text>
            <TableContentItemBadge>{item.suitabilityProfileName!}</TableContentItemBadge>
          </VStack>
          <VStack space={Spacing['stack.quarck']} flex={1} maxW={'160px'}>
            <Text fontSize={Typography['fontsize.xs']} color="neutral.dark">
              Hashtag
            </Text>
            <ItemTag data={item.tags} isListing itemId={item.customerId} />
          </VStack>
        </HStack>
        <HStack space={Spacing['stack.xxxs']} alignItems="center">
          <VStack space={Spacing['stack.quarck']} alignItems="flex-end">
            <Text fontSize={Typography['fontsize.xs']} color="neutral.dark">
              Saldo disponível
            </Text>
            <BalanceText
              balance={item.availableBalance}
              lastUpdatedAt={new Date()}
              isUpdating={isLoadingBalance}
              textAlign="flex-end"
              hasUpdateButton
              onUpdateButtonPress={handleUpdateBalance}
              positiveBalanceColor="neutral.black"
              negativeBalanceColor="feedback.error.default"
            />
          </VStack>
          <IconButton
            testId="icon-button"
            borderRadius={BoxRadius.sm}
            icon="Trash"
            onPress={handleRemoveCustomerToCart}
            p={0}
            iconColor={Color['feedback.error.default']}
            iconSize="xs"
          />
        </HStack>
      </HStack>
    </Shadow>
  );
};
